import request from '../index';

export const getIndex = () =>
  request({
    url: '/contents/index',
  });
